angular.module('theme').directive('announcementBar', function ($cookies, $document) {
	return {
		restrict: 'A',
		scope: {
			id: '@announcementBar',
			restrictions: '=',
			session: '<'
		},
		link: function ($scope, $element) {
			$scope.restricted = false;
			var currentUrl = window.location.href;
			var body = angular.element($document[0].body);
			var closeBtn = angular.element($element[0].querySelector('.announcement-bar-close'));

			_.each($scope.restrictions.split(', '), function(value) {
				if (currentUrl.indexOf(value.replace('startsida/', '')) !== -1) {
					$scope.restricted = true;
				}
			});

			if (!$cookies.get('hide-bar-'+$scope.id) && (!$scope.restrictions || $scope.restricted)) {
				body.addClass('top-bar');
				$element.addClass('d-block');
			}

			closeBtn.bind('click', function(event) {
				event.preventDefault();

				// Save cookie only for session if set
				if ($scope.session) {
					$cookies.put('hide-bar-' + $scope.id, true, {
						path: '/'
					});
				} else {
					$cookies.put('hide-bar-' + $scope.id, true, {
						path: '/',
						expires: moment().add(1, 'month').toDate()
					});
				}

				body.removeClass('top-bar');

				$element.removeClass('d-block');
				var header = document.getElementsByClassName('mk-header')[0];
				var headerHeight = header.offsetHeight;
				document.body.style.paddingTop = headerHeight + 'px';
			});

		}
	};
});
